import get from 'lodash/get';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';

const settingsOpen = (BaseComponent) => {
  return class WithSelectedProps extends PureComponent {
    static propTypes = {
      location: PropTypes.object,
    };

    render() {
      const { location } = this.props;
      const pathname = get(location, 'pathname', '');
      const showSettings = /\/settings$/.test(pathname);
      return <BaseComponent {...this.props} showSettings={showSettings} />;
    }
  };
};

export default settingsOpen;
